


























































import { Component, Vue } from "vue-property-decorator";
import { authService } from "../api/authentication/authentication.api";

@Component
export default class ResetPassword extends Vue {
  payload = {
    identifier: "",
    code: "",
    password: null,
    confirmPassword: null
  };

  errors?: any;

  get errorsMap() {
    return new Map(this.errors.items.map((error: any) => [error.field, error.message]));
  }

  async mounted() {
    try {
      const params = this.getOTPScreenPayload(this.$route.params.hash);
      if (!params.code) {
        return this.$router.push({ name: "ForgotPasswordScreen" });
      }
      this.payload.identifier = params.identifiers[0];
      this.payload.code = params.code;
    } catch (error) {
      this.$router.push({ name: "ForgotPasswordScreen" });
    } finally {
    }
  }

  async handle() {
    try {
      await this.requestWrapper<any>(
        (async () => {
          await this.validate();
          return authService.resetPassword(this.payload);
        })()
      );
      this.toastSuccess("Password reset successful, please login");
      this.$router.push({ name: "LoginScreen" });
    } catch (error) {}
  }
}
